import { ChangeDetectorRef, Component, Injectable, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CentrosService } from 'src/app/dashboard/services/centros.service';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from '@ngx-translate/core';
import { Centro } from 'src/app/dashboard/models/centro';
import { Empresa } from 'src/app/dashboard/models/empresa';
import { CustomValidators } from 'src/app/shared/custom-validator/custom-validator.component';
import { ApiService } from 'src/app/shared/services/api.service';

@Injectable()
@Component({
  selector: 'app-centros',
  templateUrl: './centros.component.html',
  styleUrls: ['./centros.component.css']
})
export class CentrosComponent implements OnInit {

  sociedad: string;
  centros: Centro[];
  allCentros: Centro[] = [];
  empresas: Empresa[];
  validatingForm: FormGroup;
  currentPage = 1;
  pageSize = 10;
  totalItems = 0;

  IsHiddenForm: boolean = false;

  id_centro: string;
  n_centro: string;
  id_empresa: string;
  n_empresa: string;
  comentarios: string;
  selectedEmpresa: string;

  constructor(
    private apiService: ApiService,
    private centersService: CentrosService,
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService,
    private changeDetectorRefs: ChangeDetectorRef,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    let language = this.auth.getLanguage();
    if (!language) language = 'es';
    this.translate.setDefaultLang(language);

    this.sociedad = this.auth.getNameSociedad();
    this.loadCentros();

    this.apiService.searchCompanyByUser(this.auth.getSociedad())
    .subscribe({
      next: (res) => {
        if(res.code === 200 && res.success){
          this.empresas = res.data;
        }
      },
      error: (err) =>{
        this.toastr.error(this.translate.instant('texto_896'));
      }
    });

    this.validatingForm = new FormGroup({
      signupFormModalName: new FormControl('', [
        Validators.required,
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ.,()\-_\[\]\/"']{2,255}$/),
        CustomValidators.secureInput
      ]),
      signupFormModalId: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9_-]{1,100}$/),
        CustomValidators.secureInput
      ]),
      signupFormModalidEmpresa: new FormControl('', [
        Validators.required
      ]),
      contactFormModalMessage: new FormControl('', [
        Validators.maxLength(4000),
        CustomValidators.secureInput
      ])
    });
  }

  loadCentros() {
    this.centersService.searchCenterByUser(this.auth.getSociedad()).subscribe((centros: Centro[]) => {
      this.centros = centros;
      this.allCentros = centros;
      this.totalItems = centros.length;
      this.updateCurrentPageCentros();
    });
  }

  getCurrentPageCentros(): Centro[] {
    return this.centros;
  }

  updateCurrentPageCentros() {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    this.centros = this.allCentros.slice(startIndex, startIndex + this.pageSize);
  }

  onPageChange(event: any) {
    this.currentPage = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.loadCentros();
  }

  get signupFormModalName() { return this.validatingForm.get('signupFormModalName'); }
  get signupFormModalId() { return this.validatingForm.get('signupFormModalId'); }
  get contactFormModalMessage() { return this.validatingForm.get('contactFormModalMessage'); }
  get signupFormModalidEmpresa() { return this.validatingForm.get('signupFormModalidEmpresa'); }

  deleteCenter(id_centro: string) {
    this.centersService.countComplaintByIdCenter(this.auth.getSociedad(), id_centro).subscribe(
      res => {
        if (res === 200) {
          this.centersService.deleteCenterByUser(this.auth.getSociedad(), id_centro).subscribe(
            res => {
              if ((res as any).success === true) {
                this.toastr.success(this.translate.instant('texto_676'), this.translate.instant('texto_679'));
              } else {
                this.toastr.error(this.translate.instant('texto_677'), this.translate.instant('texto_679'));
              }
              this.refreshComponent();
            },
            err => {
              if (err.status === 409) {
                this.toastr.error(this.translate.instant('texto_677'), this.translate.instant('texto_813'));
              } else {
                this.toastr.error(this.translate.instant('texto_677'), this.translate.instant('texto_813'));
              }
            });
        } else {
          this.toastr.error(this.translate.instant('texto_678'), this.translate.instant('texto_679'));
          this.refreshComponent();
        }
      });
  }

  showCenter(centro: Centro) {
    this.IsHiddenForm = true;
    this.id_centro = centro.id_centro;
    this.n_centro = centro.n_centro;
    this.id_empresa = centro.id_empresa;
    this.n_empresa = centro.n_empresa;
    this.comentarios = centro.comentarios;

    this.validatingForm.patchValue({
      signupFormModalId: centro.id_centro,
      signupFormModalName: centro.n_centro,
      signupFormModalidEmpresa: centro.id_empresa,
      contactFormModalMessage: centro.comentarios
    });
  }

  hideModal() {
    this.IsHiddenForm = false;
  }

  updateCenter(id_centro: string) {
    this.centersService.updateCenterByUser(
      this.auth.getSociedad(),
      id_centro,
      this.signupFormModalName.value,
      this.signupFormModalidEmpresa.value,
      this.contactFormModalMessage.value
    ).subscribe(
      res => {
        if ((res as any).success === true) {
          this.toastr.success(this.translate.instant('texto_680'), this.translate.instant('texto_682'));
        } else {
          this.toastr.error(this.translate.instant('texto_681'), this.translate.instant('texto_682'));
        }
        this.refreshComponent();
      },
      err => {
        if (err.status === 409) {
          this.toastr.error(this.translate.instant('texto_681'), this.translate.instant('texto_813'));
        } else {
          this.toastr.error(this.translate.instant('texto_681'), this.translate.instant('texto_813'));
        }
      });
  }

  private refreshComponent() {
    this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/dashboard/layout/centros']);
    });
  }
}
